import React, {useEffect, useState} from "react";
import {Button, Card, Icon, InputLabel, isEmpty, QuillEditor} from "peggirkit";
import {PencilIcon} from "@heroicons/react/16/solid";
import {FormattedMessage, useIntl} from "react-intl";
import {Controller, useFormContext, useWatch} from "react-hook-form";
import {CheckIcon} from "@heroicons/react/24/outline";
import {animatePulse} from "@/utils/LoadingUtils";
import {UpdatedJobApplication, updatedJobApplicationFormValidation} from "@/data/entities/jobApplication";
import {UpdateJobApplicationControlProps} from "@widgets/jobApplications/editor/JobApplicationEditor";

const JobApplicationInternalNote = ({initialLoading, loading, submitHandler}: UpdateJobApplicationControlProps) => {
    const intl = useIntl();
    const [showEditor, setShowEditor] = useState(false);
    const {control, formState: {errors}} = useFormContext<UpdatedJobApplication>();
    const internalNote = useWatch({
        control,
        name: "internalNote",
    });

    // Show editor initially
    useEffect(() => {
        if (!isEmpty(internalNote)) {
            setShowEditor(true);
        }
    }, [internalNote]);

    if (!showEditor) {
        return (
            <Button
                buttonClassname={animatePulse(initialLoading)}
                disabled={initialLoading || loading}
                color={"secondary"}
                iconBefore={<Icon icon={PencilIcon}/>}
                buttonAction={{
                    as: "button",
                    actionProps: {
                        onClick: e => {
                            e.preventDefault();
                            setShowEditor(true);
                        }
                    },
                }}
            >
                <FormattedMessage id={"addInternalNote"}/>
            </Button>
        );
    }

    return (
        <Card>
            <Controller
                control={control}
                name={"internalNote"}
                rules={{
                    max: {
                        value: updatedJobApplicationFormValidation.internalNote.max,
                        message: intl.formatMessage({id: "mustBeMaxCharacters"}, {
                            max: updatedJobApplicationFormValidation.internalNote.max,
                        })
                    }
                }}
                render={({field: {value, onChange}}) => (
                    <QuillEditor
                        label={<InputLabel><FormattedMessage id={"internalNote"}/></InputLabel>}
                        height={200}
                        readOnly={initialLoading || loading}
                        value={value}
                        onChange={onChange}
                        error={errors.internalNote && errors.internalNote.message}
                        containerProps={{
                            "aria-label": intl.formatMessage({id: "internalNote"})
                        }}
                    />
                )}
            />

            <div className={"w-full flex flex-row items-end justify-end mt-4"}>
                <Button
                    iconBefore={<Icon icon={CheckIcon}/>}
                    disabled={initialLoading || loading}
                    loading={loading}
                    buttonAction={{
                        as: "button",
                        actionProps: {
                            onClick: e => {
                                e.preventDefault();
                                submitHandler();
                            }
                        }
                    }}
                >
                    <FormattedMessage id={"save"}/>
                </Button>
            </div>
        </Card>
    );
};

export default JobApplicationInternalNote;